const taxi_state_color = {
  'W': "#00FF00",
  'K': "#FF33CC",
  'P': "#FFFF00",
  'B': "#000000",
  'Z': "#FF0000",
  'D': "#0000FF",
  'O': "#71DCE7",
  'O__no_order_ack': "#ff7f24",
  'F': "#996600",
  'not_active': '#a3a3a3',
};

const taxi_text_light = '#ffffff';
const taxi_text_dark = '#000000';
const taxi_text_color = {
  'W': taxi_text_dark,
  'K': taxi_text_light,
  'P': taxi_text_dark,
  'B': taxi_text_light,
  'Z': taxi_text_dark,
  'D': taxi_text_light,
  'O': taxi_text_dark,
  'O__no_order_ack': taxi_text_dark,
  'F': taxi_text_light,
  'not_active': '#525252',
};

const zone_urban_stroke_color = "#ff555555";
const zone_urban_fill_color = "#ff55554d";
const zone_urban_label_color = "#000000";

const zone_not_urban_stroke_color = "#55ff5555";
const zone_not_urban_fill_color = "#55ff554d";
const zone_not_urban_label_color = "#000000";

const color = {
  'primary': '#2196f3',
  'dark_bg': '#171717',
}

export default {
  taxi_state_color,
  taxi_text_color,
  zone_urban_stroke_color,
  zone_urban_fill_color,
  zone_urban_label_color,
  zone_not_urban_stroke_color,
  zone_not_urban_fill_color,
  zone_not_urban_label_color,
  color,
};